import { useTranslation } from "react-i18next";
import { Switch, Route } from "react-router-dom";
import { Typography } from "@material-ui/core";
import SectionHeader from "components/SectionHeader";
import Search from "./Search";
import Details from "./Details";
import EmailLogProvider from "./EmailLogProvider";

export default function EmailFlowLogs() {
  const { t } = useTranslation("emailFlowLogs");

  return (
    <EmailLogProvider>
      <SectionHeader title={t("sectionTitle")}>
        <Typography>{t("sectionDescription")}</Typography>
      </SectionHeader>
      <Switch>
        <Route path="/emailflow-logs" exact>
          <Search />
        </Route>
        <Route path="/emailflow-logs/:id" exact>
          <Details />
        </Route>
      </Switch>
    </EmailLogProvider>
  );
}
